/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconSocialThumbsUp = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M2.852 13.202a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm.75 2v-9a.5.5 0 0 0-.5-.5h-2.5a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h2.5a.5.5 0 0 0 .5-.5zm12.271-8.651c.078-.42-.033-.85-.305-1.177a1.403 1.403 0 0 0-1.062-.517h-.004l-3.591-.248a.428.428 0 0 1-.416-.32l.334-1.38c.63-1.944-.128-2.438-.375-2.543-.47-.2-1.006.051-1.291.589l-3.34 5.588c-.368.64-.645 1.034-1.221 1.087v6.369l1.167-.34c1.138.004 5.885.02 6.131-.001 1.984-.128 2.607-1.04 2.781-1.787l1.192-5.32z"
    />
  </svg>
);

IconSocialThumbsUp.displayName = 'IconSocialThumbsUp';

IconSocialThumbsUp.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconSocialThumbsUp);
IconSocialThumbsUp.displayName = 'IconSocialThumbsUp';
